<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="none" viewBox="0 0 24 24">
  <path stroke="#000" d="M12 18.417l7.5 4.083v-21h-15v21l7.5-4.083z" clip-rule="evenodd"/>
</svg>
